$('.carousel_collection').slick({
  infinite:true,
  autoplay:true,
  autoplaySpeed:5000,
  draggable:true,
  dots:true,
  arrow:true,
  slidesToShow:5,
  slidesToScroll:1,
  prevArrow:'<button type="button" class="arrow-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Arrow" x="0px" y="0px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve"> <style type="text/css"> .st0{fill:none;} .st1{clip-path:url(#SVGID_00000032642799798217351340000014898540101094121096_);} .st2{fill:#242328;} </style> <rect id="Rectangle_8170" class="st0" width="24" height="24"/> <g id="Group_4009" transform="translate(5.999 2)"> <g> <defs> <rect id="SVGID_1_" x="0" width="12" height="20"/> </defs> <clipPath id="SVGID_00000124851088600616129770000007587230346317813909_"> <use xlink:href="#SVGID_1_" style="overflow:visible;"/> </clipPath> <g id="Group_4009-2" transform="translate(0 0)" style="clip-path:url(#SVGID_00000124851088600616129770000007587230346317813909_);"> <path id="Path_19041" class="st2" d="M10.5,0C11.3,0,12,0.6,12,1.4c0,0.4-0.2,0.7-0.4,1L3.5,10l8.1,7.6c0.5,0.5,0.6,1.3,0.1,1.9     c0,0,0,0.1-0.1,0.1c-0.3,0.3-0.7,0.4-1,0.4c-0.4,0-0.7-0.1-1-0.4L0.4,11c-0.5-0.5-0.6-1.3-0.1-1.9c0,0,0,0,0.1-0.1l9.1-8.6 C9.8,0.1,10.1,0,10.5,0"/> </g> </g> </g> </svg></button>',
  nextArrow:'<button type="button" class="arrow-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Arrow" width="24" height="24" viewBox="0 0 24 24"> <defs> <clipPath id="clip-path"> <rect id="Rectangle_8464" data-name="Rectangle 8464" width="12" height="20" fill="none"/> </clipPath> </defs> <rect id="Rectangle_8170" data-name="Rectangle 8170" width="24" height="24" fill="none"/> <g id="Group_4009" data-name="Group 4009" transform="translate(5.999 2)"> <g id="Group_4009-2" data-name="Group 4009" transform="translate(0 0)" clip-path="url(#clip-path)"> <path id="Path_19041" data-name="Path 19041" d="M1.475,20A1.421,1.421,0,0,1,.023,18.62a1.325,1.325,0,0,1,.426-.971L8.5,10.01.449,2.373A1.33,1.33,0,0,1,.408.42,1.483,1.483,0,0,1,1.451,0,1.5,1.5,0,0,1,2.462.386l9.113,8.651a1.329,1.329,0,0,1,0,1.948L2.5,19.6a1.494,1.494,0,0,1-1.025.4" transform="translate(0.001 -0.001)" fill="#242328"/> </g> </g> </svg></button>',
  responsive:[
    {
      breakpoint:1024,
      settings:{
        slidesToShow:3,
        slidesToScroll:1
      }
    },
    {
      breakpoint:767,
      settings:{
        slidesToShow:1,
        slidesToScroll:1,
        centerMode:true,
        centerPadding:'20%',
        dots:true
      }
    }
  ],
  appendDots:'.collection_list_dots'
});

$('.right-product-carousel').slick({
  showOutOfStock: true,
  infinite: true,
  draggable: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none"> <path d="M4.67235 10L5.60182 9.01882L2.49941 5.69893L14.4443 5.69893V4.30108L2.49941 4.30108L5.60182 0.981183L4.67235 0L-0.000110626 5L4.67235 10Z" fill="#212121"/> </svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none"> <path d="M9.77198 -4.27147e-07L8.84251 0.981183L11.9449 4.30107L-2.49108e-07 4.30107L-1.88006e-07 5.69892L11.9449 5.69892L8.84251 9.01882L9.77198 10L14.4444 5L9.77198 -4.27147e-07Z" fill="#212121"/> </svg></button>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 959,
      settings: {
        slidesToShow: 2
      }
    }
  ]
});

// $('.left-product-carousel').slick({
//   infinite:true,
//   arrows:false,
//   draggable:false,
//   slidesToShow:1,
//   fade:true,
//   asNavFor:'.right-product-carousel'                   
// });
$('.twobyone__carousel').slick({
  infinite:true,
  autoplay:false,
  arrows:true,
  prevArrow: '<button class="slick-prev slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none"> <path d="M4.67235 10L5.60182 9.01882L2.49941 5.69893L14.4443 5.69893V4.30108L2.49941 4.30108L5.60182 0.981183L4.67235 0L-0.000110626 5L4.67235 10Z" fill="#212121"/> </svg></button>',
  nextArrow: '<button class="slick-next slick-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none"> <path d="M9.77198 -4.27147e-07L8.84251 0.981183L11.9449 4.30107L-2.49108e-07 4.30107L-1.88006e-07 5.69892L11.9449 5.69892L8.84251 9.01882L9.77198 10L14.4444 5L9.77198 -4.27147e-07Z" fill="#212121"/> </svg></button>',
  swipe:true,
  slidesToShow:1,
  dots:true,
  adaptiveHeight:false,
  responsive:[
    {
      breakpoint:960,
      settings:{
        arrows:true
      }
    }
  ]
});
$('.blogs_slider').slick({
  infinite:true,
  autoplay:true,
  autoplaySpeed:5000,
  draggable:true,
  dots:true,
  arrow:true,
  slidesToShow:3,
  slidesToScroll:1,
  appendDots:'.blog_post_slider .blog_dots-wrp',
  prevArrow:'.blog_post_slider .arrow-left-wrp',
  nextArrow:'.blog_post_slider .arrow-right-wrp',
  responsive:[
    {
      breakpoint:1024,
      settings:{
        slidesToShow:3,
        slidesToScroll:1,
        centerMode:true,
        centerPadding:'7%'
      }
    },
    {
      breakpoint:767,
      settings:{
        slidesToShow:1,
        slidesToScroll:1,
        centerMode:true,
        centerPadding:'20%'
      }
    }
  ]
});

$('#iwl_wrapper').slick({
  infinite: true,
  slidesToShow: 7,
  slidesToScroll: 3,
  arrows: true,
  centerPadding: "20px",
  swipeToSlide: true,
  prevArrow:"<button class='slick-prev slick-arrow'><svg class='Icon Icon--media-arrow-left' role='presentation' viewBox='0 0 6 9'><path d='M5 8.5l-4-4 4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
  nextArrow:"<button class='slick-next slick-arrow'><svg class='Icon Icon--media-arrow-right' role='presentation' viewBox='0 0 6 9'><path d='M1 8.5l4-4-4-4' stroke='currentColor' fill='none' fill-rule='evenodd' stroke-linecap='square'></path></svg></button>",
  responsive:[
    {
      breakpoint:767,
      settings:{
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
        centerPadding: "15px",
        swipeToSlide: true,
        centerMode: true,
        waitForAnimate: false,
        touchThreshold: 10
      }
    }
  ]
});
$(document).on('click', '.hotspot__btn', function() {
  $('.hotspot__card').removeClass('active');
  $(this).siblings('.hotspot__card').addClass('active');
});
$(document).on('click', function(event) {
  if (!$(event.target).closest('.hotspot__btn').length) {
    $('.hotspot__card').removeClass('active');
  }
});
$(document).on('click', '.menu_head', function() {
  $('.menu_head').not(this).removeClass('active');
  $(this).toggleClass('active');
  $('.footer-menu-list').not($(this).siblings('.footer-menu-list')).slideUp();
  $(this).siblings('.footer-menu-list').slideToggle();
});

$(document).on('click', '.product-tile__quick-add', function() {
  $('.quick_atc_wrp').not($(this).siblings('.quick_atc_wrp')).hide();
  $(this).siblings('.quick_atc_wrp').show();
});

$(document).on('click', '.product-tile__hide-variants', function() {
  $(this).parents('.quick_atc_wrp').hide();
});

$(document).on('change', '.product-tile__variant-input', function() {
  var variant_arr = [];
  var $_this = $(this);
  var option_size = $_this.parents('product-card').find('.product-tile__field').length;
  var qty = 0;
  var variant_policy;
  if(option_size > 1){
    for(var i = 1; i < option_size+1 ; i++) { 
      var checked_val = $_this.parents('product-card').find('.product-tile__field-'+i+' input:checked').val();
      variant_arr.push(checked_val);
    }
  }else{
    $_this.parents('product-card').find('.product-tile__field').each(function(){
      var checked_val = $(this).find('input:checked').val();
      variant_arr.push(checked_val);
    });
  }     
  var selected_var = variant_arr.join(' / ');
  $(this).parents('product-card').find('.variant_select option').each(function(){
    var option_val = $(this).data('variant-name');
    var variant_id = $(this).val();
    if(option_val == selected_var) {
      qty = $(this).data('qty');
      variant_policy = $(this).attr('ddts');
      $(this).parents('product-card').find('input[name="id"]').val(variant_id);
    }
  });
  var this_ = $(this);
  if(qty > 0) {
    setTimeout(function () {
      var variant_id = this_.parents('product-card').find('.atc_form input[name="id"]').val();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: 1,
          id: variant_id
        },
        dataType: 'json', 
        success: function (data) { 
          refreshCart(variant_id);
        } 
      });
    }, 1000);
  }else{
    window.location.href = "/products/"+ $(this).parents('.product-card').attr("handle");
  }
});
$(document).on('change', '.card_swatches input', function() {

  var selected_val = $(this).attr("data-value");
  var variant_arr = [];
  var option_size = $(this).parents('product-card').find('.product-tile__field').length;
  var $_this = $(this);
  if(option_size > 1){
    for(var i = 1; i < option_size+1 ; i++) { 
      var checked_val = $_this.parents('product-card').find('.product-tile__field-'+i+' input:checked').val();
      variant_arr.push(checked_val);
    }
  }else{
    $_this.parents('product-card').find('.product-tile__field').each(function(){
      var checked_val = $(this).find('input:checked').val();
      variant_arr.push(checked_val);
    });

  
  }    

  console.log("selected_val => "+selected_val);
 $(this).parents('.product-card').find('.size_name_div').hide();
  $(this).parents('.product-card').find(".size_"+selected_val).show();

  
  
  
  var selected_var = variant_arr.join(' / ');
  // console.log(selected_var);
  $(this).parents('product-card').find('.variant_select option').each(function(){
    var option_val = $(this).data('variant-name');
    var qty = $(this).data('qty');
    var variant_id = $(this).val();
    if(option_val == selected_var) {
      $(this).parents('product-card').find('input[name="id"]').val(variant_id);
    }
  });
});

$(document).on('click', '.product-tile__quick-add.atc_submit', function(e) {
  e.preventDefault();
  var variant_id = $(this).parents('product-card').find('.atc_form input[name="id"]').val();
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variant_id
    },
    dataType: 'json', 
    success: function (data) { 
      refreshCart(variant_id);
    } 
  });
});

function refreshCart(currentVariant) {
/*  document.documentElement.dispatchEvent(new CustomEvent('product:added', {
    bubbles: true,
    detail: {
      variant: currentVariant,
      quantity: 1
    }
  }))

  */
    var cartDrawerButtonSelector = "header_cart_icon";
	   var cartDrawerButton = document.getElementsByClassName(cartDrawerButtonSelector)[0];
       console.log("cartDrawerButton"+cartDrawerButton);      
	  cartDrawerButton.click();
       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
         bubbles: true,
        detail: {
          baseEvent: "variant:add",
          onSuccessDo: null
                }
      }))
      return false;
}
$('.product_card_imgs').slick({
  infinite:true,
  autoplay:true,
  autoplaySpeed:3000,
  draggable:false,
  dots:false,
  arrow:false,
  slidesToShow:1,
  slidesToScroll:1
});
$('.CollectionList').slick({
  infinite:true,
  arrows:false,
  dots:false,
  draggable:false,
  autoplay:true,
  autoplaySpeed:2000,
  slidesToShow:5,
  responsive:[
    {
      breakpoint:767,
      settings:{
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true,
        waitForAnimate: false,
        touchThreshold: 10
      }
    }
  ]
});








$(document).on('click', '.signin_tab', function() {
  $(this).addClass('active_tab');
  $(this).siblings('.signup_tab').removeClass('active_tab');
  $(this).parents('.account_popup_wrapper').find('.signin_form').addClass('active_form');
  $(this).parents('.account_popup_wrapper').find('.signup_form').removeClass('active_form');
});
$(document).on('click', '.signup_tab', function() {
  $(this).addClass('active_tab');
  $(this).siblings('.signin_tab').removeClass('active_tab');
  $(this).parents('.account_popup_wrapper').find('.signup_form').addClass('active_form');
  $(this).parents('.account_popup_wrapper').find('.signin_form').removeClass('active_form');
});